export default function GiftingHomepageTickerIcon() {
  // const viewBox = '0 0 512.001 512.001';
  return (
    <>
      <g>
        <g>
          <path
            d='M366.965,182.204c17.836-13.624,29.374-35.096,29.374-59.223c0-41.078-33.419-74.497-74.497-74.497
			c-29.306,0-54.704,17.017-66.859,41.683c-12.155-24.666-37.553-41.683-66.859-41.683c-41.078,0-74.497,33.419-74.497,74.497
			c0,24.126,11.537,45.599,29.374,59.223H52.303v81.813h12.42v247.985h149.354h15.274h51.263h15.274h149.354V264.016h12.42v-81.813
			H366.965z M214.077,496.726H79.997v-232.71h134.079V496.726z M214.077,248.741h-146.5v-51.264h120.546h25.953V248.741z
			 M214.077,182.204h-25.953c-32.656,0-59.223-26.567-59.223-59.223c0-32.656,26.567-59.223,59.223-59.223
			c32.655,0,59.222,26.567,59.222,59.223v59.223h-17.994H214.077z M280.614,248.741v15.274v232.71h-51.263v-232.71v-15.274v-51.264
			h17.994h15.274h17.994V248.741z M280.614,182.204H262.62v-59.223c0-32.656,26.567-59.223,59.222-59.223
			c32.656,0,59.223,26.567,59.223,59.223c0,32.656-26.567,59.223-59.223,59.223h-25.953H280.614z M429.968,496.726h-0.001H295.889
			v-232.71h134.079V496.726z M442.388,248.742h-146.5v-51.264h25.953h120.546V248.742z'
          />
        </g>
      </g>
      <g>
        <g>
          <rect x='405.413' y='429.271' width='15.274' height='16.936' />
        </g>
      </g>
      <g>
        <g>
          <polygon points='405.409,456.497 405.409,475.035 376.477,475.035 376.477,490.309 420.683,490.309 420.683,456.497 		' />
        </g>
      </g>
      <g>
        <g>
          <rect x='88.755' y='313.094' width='15.274' height='71.596' />
        </g>
      </g>
      <g>
        <g>
          <rect x='88.755' y='277.841' width='15.274' height='25.099' />
        </g>
      </g>
      <g>
        <g>
          <polygon points='458.665,100.785 451.082,108.368 443.422,100.706 432.621,111.507 451.082,129.97 469.464,111.586 		' />
        </g>
      </g>
      <g>
        <g>
          <polygon points='68.579,60.736 60.998,68.318 53.336,60.658 42.537,71.458 60.998,89.919 79.38,71.536 		' />
        </g>
      </g>
      <g>
        <g>
          <polygon points='242.358,0.079 234.775,7.661 227.114,0 216.313,10.8 234.775,29.263 253.158,10.879 		' />
        </g>
      </g>
    </>
  );
}
